import { useContext } from "react";
import type { ReactNode } from "react";
import UserContext from "../contexts/user";

interface ContentPageProps {
  title: ReactNode;
  children: ReactNode;
}

export default function ContentPage({ title, children }: ContentPageProps) {
  const { user, isUserLoading } = useContext(UserContext);

  if (isUserLoading || !user) {
    return (
      <div className="flex h-full w-full items-center justify-center py-10 text-blue-200">
        Loading...
      </div>
    );
  }

  return (
    <div className="mx-auto h-full w-full max-w-[1400px] px-10 pb-16 pt-[2.36rem]">
      <h1 className="flex w-full items-center justify-center text-4xl text-blue-200">
        {title}
      </h1>
      <div className="h-full w-full pt-[2rem]">{children}</div>
    </div>
  );
}
